import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1950dab9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "m-redeemable-tokens"
}
const _hoisted_2 = { class: "m-redeemable-tokens-tabs" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Eligible Tokens ")
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Claimed Tokens ")
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "m-redeemable-tokens-list"
}
const _hoisted_8 = {
  key: 1,
  class: "m-redeemable-tokens-list"
}
const _hoisted_9 = {
  key: 1,
  class: "m-redeemable-tokens-none"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "You have no eligible tokens for rewards on this product!", -1))
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_reward = _resolveComponent("m-reward")!
  const _component_m_token_add_to_cart = _resolveComponent("m-token-add-to-cart")!

  return (_ctx.eligibleRewards.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: _normalizeClass({ selected: _ctx.showEligibleTab }),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showEligibleTab = true))
          }, [
            _hoisted_3,
            (_ctx.eligibleRewards.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.eligibleRewards.length), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("button", {
            class: _normalizeClass({ selected: !_ctx.showEligibleTab }),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showEligibleTab = false))
          }, [
            _hoisted_5,
            (_ctx.redeemedTokens.length > 0 || _ctx.redeemedTokensByOthers.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.redeemedTokens.length + _ctx.redeemedTokensByOthers.length), 1))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        (_ctx.eligibleRewards && _ctx.showEligibleTab)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eligibleRewards, (reward, idx) => {
                return (_openBlock(), _createBlock(_component_m_reward, {
                  key: idx,
                  reward: reward,
                  "on-click": _ctx.addToCart,
                  "adding-to-cart": _ctx.addingToCart,
                  cta: _ctx.claimText,
                  "wallet-limit-reached": _ctx.walletLimitReached(reward)
                }, null, 8, ["reward", "on-click", "adding-to-cart", "cta", "wallet-limit-reached"]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (!_ctx.showEligibleTab)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.redeemedTokens, (token, idx) => {
                return (_openBlock(), _createBlock(_component_m_token_add_to_cart, {
                  key: idx,
                  token: token
                }, null, 8, ["token"]))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.redeemedTokensByOthers, (token, idx) => {
                return (_openBlock(), _createBlock(_component_m_token_add_to_cart, {
                  key: idx,
                  token: token,
                  "on-click": () => {},
                  cta: 'Redeemed by Someone Else'
                }, null, 8, ["token", "on-click"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
}